/* eslint-disable */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  makeStyles,
  createStyles,
  Box,
  Button,
  Card,
  CardHeader,
  Input,
  Theme,
  withStyles,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
  HStack,
  Circle,
  Heading,
  Image,
  Checkbox,
  Container,
} from "@chakra-ui/react";
import { Row } from "reactstrap";
import {
  get_all_questions_configuration,
  getAllRiskCriteriasConfigurations,
  add_questions_configuration,
  delete_questions_configuration,
} from "../../utils/store/actions/risk.actions";
import { getSections, getEnums } from "../../utils/store/actions/survey.action";
import SelectAllButton from "../../components/ConfigQuestionnaire/SelectAllButton";
import { faLaptopHouse } from "@fortawesome/free-solid-svg-icons";

const useStyles = (theme: Theme) =>
  createStyles({
    root: {
      // width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "20%",
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
      flexBasis: "40.33%",
    },
    paper: {
      width: "80%",
      backgroundColor: "#F5F6FF",
      margin: "7%",
      overflow: "hidden",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    weight: {
      display: "flex",
      marginLeft: "10vh",
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
    },
    table: {
      height: "30vh",
    },
  });
class RiskQuestions extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: true,
      checked: [],
    };
  }
  componentDidMount() {
    this.props
      .getSections("client")
      .then(() =>
        this.setState({ loading: false, surveys: this.props.Surveys.sections })
      );
    this.props.getEnums();
    this.props.getAllRiskCriteriasConfigurations().then(() => {
      this.setState({
        criteria: this.props.Risk.risk_criterias_configurations.content,
      });
    });
    this.props.get_all_questions_configuration().then(() => {
      this.setState({ checked: this.props.Risk.risk_questions });
    });
  }

  selectAll = (e: any, c: any, id: any): any => {
    // find all fields in section
    let array: any = [];
    this.props.Surveys.sections.forEach((structure: any) => {
      const tempArray = structure.subSection.filter(
        (section: any) => section.name === id
      );
      if (tempArray.length > 0) {
        array = tempArray;
      }
    });
    let keyArray: any = [];
    array[0].questions.forEach((question: any) => {
      keyArray.push({ key: question.key });
    });
    this.setState({ keyArray: keyArray });
    this.handleCheckbox(e, c, keyArray);
  };
  handleCheckbox(e: any, c: any, q: any) {
    let key: any = [];
    if (q.length > 1) {
      key = q;
    } else {
      key = [
        {
          key: `${q.key}`,
        },
      ];
    }

    if (e.target.checked) {
      this.props.add_questions_configuration(c.id, key).then(() => {
        this.props.get_all_questions_configuration().then(() => {
          this.setState({ checked: this.props.Risk.risk_questions });
        });
      });
    } else {
      this.props.delete_questions_configuration(c.id, key).then(() => {
        this.props.get_all_questions_configuration().then(() => {
          this.setState({ checked: this.props.Risk.risk_questions });
        });
      });
    }
  }
  componentWillUnmount() {
    this.props.get_all_questions_configuration().then(() => {
      this.setState({ checked: this.props.Risk.risk_questions });
    });
  }
  render() {
    if (
      this.props.Surveys.sort_sections &&
      this.props.Surveys.sections &&
      this.props.Risk.risk_criterias_configurations.content &&
      this.props.Risk.risk_questions
    ) {
      if (this.state.loading) {
        return <CircularProgress color="inherit" />;
      } else {
        const { t, classes } = this.props;
        return (
          <div>
            <Box
              style={{
                margin: "50px",
                display: "flex",
                alignItems: "top",
              }}
            >
              <HStack cursor="pointer">
                <Heading
                  fontSize="18px"
                  fontFamily="Inter, sans-serif"
                  color="brand.bf3"
                >
                  {t("CONFIGURATION_OF_RISK_PROFILE_QUESTIONS")}
                </Heading>
                <Image src="/icon/check-circle.svg" />
              </HStack>
            </Box>
            <Box
              style={{
                display: "flex",
                margin: "50px",
                flexDirection: "column",
              }}
            >
              <span>{t("DEFINE_RISK_PROFILE_QUESTIONS")}</span>
              <span>{t("DEFINE_CRITERIA_QUESTIONS")}</span>
            </Box>
            <Paper className={classes.paper}>
              <Row
                style={{
                  display: "block",
                  marginRight: "0px",
                  marginLeft: "0px",
                }}
              >
                <div className={classes.root}>
                  {this.state.surveys?.map(
                    (sec: any) =>
                      (sec.label === "STRUCTURE.QUESTIONNAIRE" ||
                        sec.label === "STRUCTURE.SUBSCRIPTION") && (
                        <Accordion key={sec.id}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions1-content"
                            id="additional-actions1-header"
                          >
                            {t(`distributor:${sec.label}`)}
                          </AccordionSummary>
                          <AccordionDetails style={{ maxHeight: "60vh" }}>
                            <TableContainer component={Paper}>
                              <Table stickyHeader aria-label="a dense table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell></TableCell>
                                    {this.state.criteria?.map((c: any) => (
                                      <TableCell id={`${c.id}`} align="center">
                                        {t(c.criteria)[0].toUpperCase() +
                                          t(c.criteria).slice(1).toLowerCase()}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {sec.questions?.length
                                    ? sec?.questions
                                        .sort((a: any, b: any) =>
                                          a.questionOrder &&
                                          b.questionOrder &&
                                          a.questionOrder > b.questionOrder
                                            ? 1
                                            : -1
                                        )
                                        .map(
                                          (q: any) =>
                                            (q.type === "SELECT" ||
                                              q.type === "RADIO" ||
                                              q.type === "CHECKBOX" ||
                                              q.type === "SELECT_MULTIPLE") && (
                                              <TableRow>
                                                <TableCell
                                                  component="th"
                                                  scope="row"
                                                >
                                                  <>
                                                    [{q.key}] {t(q.label)}
                                                    {q.personType && (
                                                      <small>
                                                        ({t(q.personType)})
                                                      </small>
                                                    )}
                                                  </>
                                                </TableCell>
                                                {this.state.criteria?.map(
                                                  (c: any) => (
                                                    <TableCell
                                                      size="small"
                                                      align="right"
                                                    >
                                                      <Checkbox
                                                        onChange={(e: any) => {
                                                          this.handleCheckbox(
                                                            e,
                                                            c,
                                                            q
                                                          );
                                                        }}
                                                        id={`${q.key}_${c.id}`}
                                                        isChecked={this.state.checked.some(
                                                          (rq: any) => {
                                                            if (
                                                              rq.key ===
                                                                q.key &&
                                                              rq
                                                                .criteriaConfiguration
                                                                .criteria ===
                                                                c.criteria
                                                            ) {
                                                              return true;
                                                            } else {
                                                              return false;
                                                            }
                                                          }
                                                        )}
                                                        inputProps={{
                                                          "aria-label":
                                                            "primary checkbox",
                                                        }}
                                                      />
                                                    </TableCell>
                                                  )
                                                )}
                                              </TableRow>
                                            )
                                        )
                                    : sec?.subSection
                                        .sort((a: any, b: any) =>
                                          a.sectionOrder &&
                                          b.sectionOrder &&
                                          a.sectionOrder > b.sectionOrder
                                            ? 1
                                            : -1
                                        )
                                        .map(
                                          (sub: any) =>
                                            sub.label !==
                                              "SECTION.COUNTER_SIGNATORY" &&
                                            sub.label !==
                                              "SECTION.DOCUMENTS" && (
                                              <>
                                                <TableRow
                                                  style={{
                                                    backgroundColor:
                                                      "lightgrey",
                                                  }}
                                                >
                                                  <TableCell
                                                    component="th"
                                                    scope="row"
                                                  >
                                                    {t(
                                                      `distributor:${sub.label}`
                                                    )}
                                                  </TableCell>

                                                  {this.state.criteria?.map(
                                                    (c: any) => (
                                                      <TableCell
                                                        size="small"
                                                        align="right"
                                                      >
                                                        <Checkbox
                                                          onChange={(
                                                            e: any
                                                          ) => {
                                                            this.selectAll(
                                                              e,
                                                              c,
                                                              sub.name
                                                            );
                                                          }}
                                                          defaultIsChecked={sub.questions
                                                            .map(
                                                              (
                                                                question: any
                                                              ) => {
                                                                return this
                                                                  .state.checked
                                                                  .length !== []
                                                                  ? question.key ===
                                                                      this.state.checked.find(
                                                                        (
                                                                          checked: any
                                                                        ) =>
                                                                          checked.key ===
                                                                            question.key &&
                                                                          checked
                                                                            .criteriaConfiguration
                                                                            .criteria ===
                                                                            c.criteria
                                                                      )?.key
                                                                  : false;
                                                              }
                                                            )
                                                            .every(
                                                              (answer: any) => {
                                                                return (
                                                                  answer ===
                                                                  true
                                                                );
                                                              }
                                                            )}
                                                          inputProps={{
                                                            "aria-label":
                                                              "primary checkbox",
                                                          }}
                                                        />
                                                      </TableCell>
                                                    )
                                                  )}
                                                </TableRow>
                                                {sub.questions
                                                  .sort((a: any, b: any) =>
                                                    a.questionOrder &&
                                                    b.questionOrder &&
                                                    a.questionOrder >
                                                      b.questionOrder
                                                      ? 1
                                                      : -1
                                                  )
                                                  .map(
                                                    (q: any) =>
                                                      (q.type === "SELECT" ||
                                                        q.type === "RADIO" ||
                                                        q.type === "CHECKBOX" ||
                                                        q.type ===
                                                          "SELECT_MULTIPLE") && (
                                                        <TableRow
                                                          style={{
                                                            backgroundColor: `${
                                                              q.type ===
                                                                "TITLE" &&
                                                              "#C7A3D1"
                                                            }`,
                                                          }}
                                                        >
                                                          <TableCell
                                                            component="th"
                                                            scope="row"
                                                          >
                                                            [{q.key}] {t(q.label)}
                                                            {q.personType && (
                                                              <small>
                                                                (
                                                                {t(
                                                                  q.personType
                                                                )}
                                                                )
                                                              </small>
                                                            )}
                                                          </TableCell>
                                                          {this.state.criteria?.map(
                                                            (c: any) => (
                                                              <TableCell
                                                                size="small"
                                                                align="right"
                                                              >
                                                                <Checkbox
                                                                  onChange={(
                                                                    e: any
                                                                  ) => {
                                                                    this.handleCheckbox(
                                                                      e,
                                                                      c,
                                                                      q
                                                                    );
                                                                  }}
                                                                  id={`${q.key}_${c.id}`}
                                                                  isChecked={this.state.checked.some(
                                                                    (
                                                                      rq: any
                                                                    ) => {
                                                                      if (
                                                                        rq.key ===
                                                                          q.key &&
                                                                        rq
                                                                          .criteriaConfiguration
                                                                          .criteria ===
                                                                          c.criteria
                                                                      ) {
                                                                        return true;
                                                                      } else {
                                                                        return false;
                                                                      }
                                                                    }
                                                                  )}
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "primary checkbox",
                                                                  }}
                                                                />
                                                              </TableCell>
                                                            )
                                                          )}
                                                        </TableRow>
                                                      )
                                                  )}
                                              </>
                                            )
                                        )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </AccordionDetails>
                        </Accordion>
                      )
                  )}
                </div>
              </Row>
            </Paper>
          </div>
        );
      }
    } else {
      return (
        <>
          {/* Page content */}
          <Container className="mt--7" fluid>
            {/* Table */}
            <Row>
              <div className="col">
                <Card className="shadow">
                  <CardHeader className="fa5 border-0">
                    <h3 className="mb-0">Questions disponibles</h3>
                  </CardHeader>
                </Card>
              </div>
            </Row>
          </Container>
        </>
      );
    }
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getEnums,
  getSections,
  get_all_questions_configuration,
  getAllRiskCriteriasConfigurations,
  add_questions_configuration,
  delete_questions_configuration,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withTranslation()(RiskQuestions)));
